/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 24.05.17.
 */

import React from "react";
import PropTypes from "prop-types";
import t from "../../trans";
import {Modal, FormGroup} from "../../components/Bootstrap";

class ForgotPasswordModal extends React.Component {
    static propTypes = {
        /**
         * Active person role ID
         */
        email: PropTypes.string,
        readOnly: PropTypes.bool,
        resetCode: PropTypes.bool,
        /**
         * onChange(fieldName, value)
         */
        onChange: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired
    };

    static defaultProps = {
    };

    constructor(props) {
        super(props);
        this.state = {};
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    onSubmit(e) {
        e.preventDefault();
        this.props.onSubmit();
    }

    onChange(e) {
        e.preventDefault();
        this.props.onChange(e.target.name, e.target.value);
    }

    render() {
        let helpText = (this.props.readOnly ? t("Password reset link will be sent to this e-mail adress") : t("Enter your e-mail adress and we will send you password reset link"));
        if (this.props.resetCode) {
            helpText = this.props.readOnly ?
                t("Authentication code reset link will be sent to this e-mail adress") :
                t("Enter your e-mail adress and we will send you authentication code reset link");
        }
        return (
            <Modal modalClass="inmodal fade" modalAttrib={{"data-backdrop": "static", "data-keyboard": "false"}} id="selectRole" tabIndex="-1" role="dialog" aria-hidden="true" onClose={this.props.onClose}>
                <Modal.Content>
                    <Modal.Header>
                        <button type="button" className="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span className="sr-only">{t("Close")}</span></button>
                        <h4 className="modal-title">{this.props.resetCode ? t("Reset authentication code") : t("Remind password")}</h4>
                    </Modal.Header>
                    <Modal.Body>
                        <form className="form-horizontal">
                            <FormGroup label={t("E-mail")} inputId="email" helpText={helpText} >
                                {
                                    this.props.readOnly ?
                                        <p className="form-control-static">{this.props.email}</p> :
                                        <input type="email" className="form-control" name="email" id="email"
                                               value={this.props.email} onChange={this.onChange} required={true}/>
                                }
                            </FormGroup>
                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-white" data-dismiss="modal">{t("Cancel")}</button>
                        <button type="button" className="btn btn-primary" onClick={this.onSubmit}>{this.props.readOnly ? t("Send reset link") : t("Request reset link")}</button>
                    </Modal.Footer>
                </Modal.Content>
            </Modal>
        );
    }
}

export default ForgotPasswordModal;
